import React, { useEffect } from 'react'

import cn from 'classnames'

import styles from './BaseDropDownItem.module.scss'
import { BaseDropDownItemProps } from './types'

const BaseDropDownItem: React.FC<BaseDropDownItemProps> = ({
  isSelected,
  onClick,
  onKeyDown,
  onMouseOver,
  isCustom,
  isActive,
  children,
}) => {
  const liRef = React.createRef<HTMLLIElement>()
  useEffect(() => {
    if (isActive) {
      liRef.current!.focus()
    }
  }, [isActive])

  return (
    <li
      ref={liRef}
      role="tab"
      tabIndex={0}
      aria-selected={isSelected}
      className={cn(
        !isCustom && styles.dropDownItem,
        !isCustom && isSelected && styles.selected,
        !isCustom && isActive && styles.active,
      )}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseOver={onMouseOver}
      onFocus={onMouseOver}
    >
      {children}
    </li>
  )
}

export default BaseDropDownItem
